'use strict';

import util from '../util';

/**
 * @function
 * @description Selects the first address from the list of addresses
 */

var processstates = {
    init:  function () {
		
	    $(document).on('change', 'select.country', function(e) {
	    	var $this = $(this);
	    	
	    	var $form = $this.closest('form');
	    	var $state = $('select.state', $form);
	    	
	    	var value = $state.val();
	    	
	    	var countryCode = $this.val();
	    	var countryData = window.Countries[countryCode];
	    	var regions = countryData && countryData.regions ? countryData.regions :{};
	    	
	    	var list_title = countryCode=='ca'?'Province':'State';
	    	var list_options = [];
	    	list_options.push('<option class="select-option" value="" label="'+list_title+'">'+list_title+'</option>');
	    	$.each(regions, function(key, value) {
	    		list_options.push('<option class="select-option" value="'+key+'" label="'+value+'">'+value+'</option>');
	    	});
	    	$state.html(list_options.join('')).val(value);
	    	$state.prop('selectedIndex', 0);
	    	
	    	
	    });
    },
    refreshStates: function($form){
        if($('select.state', $form).length && $('select.country', $form).length){
            var $state = $('select.state', $form);
            var value = $state.val();
            var countryCode = $('select.country', $form).val();
            var countryData = window.Countries[countryCode];
            var regions = countryData && countryData.regions ? countryData.regions :{};
			
            var list_title = countryCode=='ca'?'Province':'State';
            var list_options = [];
            list_options.push('<option class="select-option" value="" label="'+list_title+'">'+list_title+'</option>');
            $.each(regions, function(key, value) {
                list_options.push('<option class="select-option" value="'+key+'" label="'+value+'">'+value+'</option>');
            });
            $state.html(list_options.join('')).val(value);
            $state.val(value);
        }
    }
};

export default processstates;
